import type { Editor } from '@tiptap/core'

export function applyRewriteResultToEditor(
  editor: Editor,
  rewriteResult: string,
  rewriteRange: { from: number; to: number }
): void {
  editor
    .chain()
    .focus()
    .insertContentAt(
      { from: rewriteRange.from, to: rewriteRange.to },
      rewriteResult,
      { contentType: 'markdown' }
    )
    .run()
}
